import { render, staticRenderFns } from "./DynamicPage.vue?vue&type=template&id=b1cd97b8&scoped=true"
import script from "./DynamicPage.vue?vue&type=script&lang=js"
export * from "./DynamicPage.vue?vue&type=script&lang=js"
import style0 from "./DynamicPage.vue?vue&type=style&index=0&id=b1cd97b8&prod&scoped=true&lang=scss"
import style1 from "./DynamicPage.vue?vue&type=style&index=1&id=b1cd97b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cd97b8",
  null
  
)

export default component.exports